import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    user: null,
    token: null,
    fetch: false,
    dataFetched: false,
    selectedLocation: null,
};

export const profileSlice = createSlice({
    name: "profileInfo",
    initialState,
    reducers: {
        setUserData: (state, action) => { state.user = action.payload; },
        setToken: (state, action) => { state.token = action.payload; },
        fetchData: (state, action) => { state.fetch = action.payload; },
        profileData: (state, action) => { state.dataFetched = action.payload; },
        setSelectedLocation: (state, action) => { state.selectedLocation = action.payload; },
    },
});

export const { setUserData, setToken, fetchData, profileData, setSelectedLocation } = profileSlice.actions;

export default profileSlice.reducer;